<template>
  <div>
    <wc-data-box
      :title='basics.title'
      :titleIcon='basics.icon'
      :titleIconColor='basics.iconColor'
    >
      <wc-two-column-table :items='items'></wc-two-column-table>
    </wc-data-box>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import projectServices from '@/modules/projects/services/projects'

export default {
  name: 'wo-basics',
  props: {
    wo: {
      required: true
    }
  },
  computed: {
    objRoute () {
      if (this.wo.project) {
        return { name: this.wo.project_obj.division_obj.division + 'Overview', params: { id: this.wo.project } }
      } else if (this.wo.estimate) {
        return { name: this.wo.estimate_obj.division_obj.division + 'Estimate', params: { id: this.wo.estimate } }
      }
      return '/'
    },
    generatedFromRoute () {
      if (this.wo.generated_from_estimate) {
        return { name: this.wo.project_obj.division_obj.division + 'Estimate', params: { id: this.wo.generated_from_estimate } }
      }
      return null
    },
    items () {
      let i = []
      if (this.wo.project) {
        i.push(
          { text: 'Number', value: this.wo.number },
          { text: 'Project', value: this.wo.project_obj.name, route: this.objRoute },
          { 
            text: 'Invoice',
            value: this.wo.invoice_obj ? this.wo.invoice_obj.number : 'none',
            route: this.wo.invoice_obj ? { name: 'InvoiceOverview', params: { id: this.wo.invoice_obj.id } } : ''
          },
          { text: 'Site Address', value: this.wo.project_obj.site_address },
          { text: 'Site City', value: this.wo.project_obj.site_city },
          { text: 'Created On', value: this.$options.filters.shortDate(this.wo.date_created) },
          { text: 'Created By', value: this.wo.created_by_obj ? this.wo.created_by_obj.name_display : '' },
          { text: 'Scheduled For', value: this.$options.filters.shortDate(this.wo.scheduled_for) }
        )
        if (this.wo.generated_from_estimate) {
          i.push({ text: 'Generated from', value: '(Estimate link)', route: this.generatedFromRoute })
        }
        if (this.wo.route) {
          i.push({ text: 'Route Lead', value: this.wo.route_obj.lead_obj ? this.wo.route_obj.lead_obj.name_display : '(n/a)' })
        }
        if (this.wo.date_completed) {
          i.push({ text: 'Date Completed', value: this.$options.filters.shortDate(this.wo.date_completed) })
        }
      } else {
        i.push(
          { text: 'Number', value: this.wo.number },
          { text: 'Estimate', value: this.wo.estimate_obj.name, route: this.objRoute },
          { 
            text: 'Invoice',
            value: this.wo.invoice_obj ? this.wo.invoice_obj.number : 'none',
            route: this.wo.invoice_obj ? { name: 'InvoiceOverview', params: { id: this.wo.invoice_obj.id } } : ''
          },
          { text: 'Site Address', value: this.wo.estimate_obj.site_address },
          { text: 'Site City', value: this.wo.estimate_obj.site_city },
          { text: 'Created On', value: this.$options.filters.shortDate(this.wo.date_created) },
          { text: 'Created By', value: this.wo.created_by_obj ? this.wo.created_by_obj.name_display : '' },
          { text: 'Scheduled For', value: this.$options.filters.shortDate(this.wo.scheduled_for) }
        )
        if (this.wo.route) {
          i.push({ text: 'Route Lead', value: this.wo.route_obj.lead_obj ? this.wo.route_obj.lead_obj.name_display : '(n/a)' })
        }
        if (this.wo.date_completed) {
          i.push({ text: 'Date Completed', value: this.$options.filters.shortDate(this.wo.date_completed) })
        }
      }
      return i
    },
    ...mapState({
      basics: state => state.icons.dataBox.basics
    })
  }
}
</script>
